import type { FC } from "react";

import { t } from "i18n/i18n";

export interface ProgressBarProps {
  count: number;
  total: number;
}

export const ProgressBar: FC<ProgressBarProps> = ({ count, total }) => {
  const percentage = total === 0 ? 0 : Math.ceil((count / total) * 100);
  const safePercentage = Math.min(100, Math.max(0, percentage));

  return (
    <>
      <div className="flex w-full max-w-[1000px] flex-grow">
        <div className="h-3 w-full rounded-full bg-green-tint-70">
          <div
            className="duration-400 h-3 rounded-full bg-green-shade-20 transition-[width] ease-in-out"
            style={{ width: `${safePercentage}%` }}
          />
        </div>
      </div>

      <div className="flex w-[40px] items-center justify-start">
        {t("common.percentage", { number: safePercentage })}
      </div>
    </>
  );
};
